import clsx from 'clsx';
import type { FC } from 'react';

import { PabblyLogo } from './pabbly-logo';
import { authHeaderWrapper } from './share.css';

export const AuthHeader: FC<{
  title: string;
  subTitle?: string;
  className?: string;
}> = ({ title, subTitle, className }) => {
  return (
    <div className={clsx(authHeaderWrapper, className)}>
      <PabblyLogo className="logo" />
      <p>{title}</p>
      <p>{subTitle}</p>
    </div>
  );
};
